export function delay(duration: number) {
    return new Promise<void>(function (resolve) {
        setTimeout(() => resolve(), duration)
    })
}
